import { useEffect, useRef, useState } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import "./GPXMap.css";

export default function GPXMap({ result }) {
  const mapRef = useRef(null); // ref for the container div
  const leafletMapRef = useRef(null); // ref to store Leaflet map instance
  const [gpxUrl, setGpxUrl] = useState(null);

  useEffect(() => {
    const gpxBlob = new Blob([Uint8Array.from(atob(result.gpx_base64), c => c.charCodeAt(0))], { type: "application/gpx+xml" });
    const gpxUrl = URL.createObjectURL(gpxBlob);
    setGpxUrl(gpxUrl);

    if (!gpxUrl || !mapRef.current) return;

    // Destroy previous map if exists
    if (leafletMapRef.current) {
      leafletMapRef.current.remove();
      leafletMapRef.current = null;
    }

    // Create new map
    const map = L.map(mapRef.current).setView([39.1419, -84.4991], 13);
    leafletMapRef.current = map;

    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution: "&copy; OpenStreetMap contributors"
    }).addTo(map);

    fetch(gpxUrl)
      .then(res => res.text())
      .then(gpxText => {
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(gpxText, "application/xml");
        const trkpts = xmlDoc.getElementsByTagName("trkpt");

        const latlngs = [];
        for (let i = 0; i < trkpts.length; i++) {
          const lat = parseFloat(trkpts[i].getAttribute("lat"));
          const lon = parseFloat(trkpts[i].getAttribute("lon"));
          latlngs.push([lat, lon]);
        }

        if (latlngs.length > 0) {
          const polyline = L.polyline(latlngs, { color: "blue", weight: 3 }).addTo(map);
          map.fitBounds(polyline.getBounds());
        } else {
          console.warn("No track points found in GPX");
        }
      })
      .catch(err => console.error("Failed to load GPX:", err));

    return () => {
      if (leafletMapRef.current) {
        leafletMapRef.current.remove();
        leafletMapRef.current = null;
      }
    };
  }, [result]);

  const handleDownload = () => {
    if (!gpxUrl) return;
    const a = document.createElement("a");
    a.href = gpxUrl;
    a.download = "route.gpx";
    a.click();
  };

  return (
    <div class='gpx-map'>
      <div ref={mapRef} style={{ height: "400px", width: "400px" }} />
      <div class='map-info'>
        <div>Distance: {(result.score / 1000).toFixed(1)} km - {(result.score / 1609.344).toFixed(1)} mi</div>
        <button type='button' onClick={handleDownload}>Download</button>
      </div>
    </div>
  );
}
